import React from 'react';
import './css/Location.css';

const Location: React.FC = () => {
    return (
        <div className="location-page">
            <div className="main-content">
                <div className="content-container">
                    <div className="info-section">
                        <div className="section-header">
                            <h2>Холбоо Барих Мэдээлэл</h2>
                        </div>
                        <div className="info-container">
                            {/* <div className="location-info card-style">
                                <div className="contact-icon-container">
                                    <div className="contact-icon">📍</div>
                                </div>
                                <div className="contact-text">
                                    <h3>Хаяг байршил</h3>
                                    <p>Эрдэнэт хот, Баян-Өндөр сум, Говил багт байрлах хуучин эсгий гутлын үйлдвэрийн байр.</p>
                                </div>
                            </div> */}
                            <div className="contact-row">
                                <div className="contact-info card-style">
                                    <div className="contact-icon-container">
                                        <div className="contact-icon">📍</div>
                                    </div>
                                    <div className="contact-text">
                                        <h3>Хаяг байршил</h3>
                                        <p className="hover-effect">Эрдэнэт хот, Баян-Өндөр сум, Говил багт байрлах хуучин эсгий гутлын үйлдвэрийн байр.</p>
                                    </div>
                                </div>
                                <div className="contact-info card-style">
                                    <div className="contact-icon-container">
                                        <div className="contact-icon">📍</div>
                                    </div>
                                    <div className="contact-text">
                                        <h3>Манай Оффис</h3>
                                        <p className="hover-effect">Амгалан оршихуй 1 давхар 105 тоот</p>
                                    </div>
                                </div>
                            </div>

                            <div className="contact-row">
                                <div className="contact-info card-style">
                                    <div className="contact-icon-container">
                                        <div className="contact-icon">📞</div>
                                    </div>
                                    <div className="contact-text">
                                        <h3>Холбогдох утас</h3>
                                        <p className="hover-effect">(+976) 7707-1771</p>
                                        <p className="hover-effect">(+976) 9911-6810</p>
                                    </div>
                                </div>

                                <div className="contact-info card-style">
                                    <div className="contact-icon-container">
                                        <div className="contact-icon">✉️</div>
                                    </div>
                                    <div className="contact-text">
                                        <h3>Имэйл хаяг</h3>
                                        <p className="hover-effect">info@erdenetcars.mn</p>
                                        <p className="hover-effect" >&nbsp; </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="map-section">
                        <div className="section-header">
                            <h2>Бидний Байршил</h2>
                        </div>
                        <div className="map-container">
                            <iframe
                                className="location-map"
                                src="https://maps.google.com/maps?q=49.058733,104.127512&z=15&t=k&output=embed"
                                loading="lazy"
                                allowFullScreen
                                referrerPolicy="no-referrer-when-downgrade"
                                title="Google Map Satellite View with Marker"
                            />
                        </div>
                    </div>
                </div>
            </div>


        </div >
    );
};

export default Location;